export const Pulse = ({ className = "", strokeWidth = 4.2, gradient = true, id = "pulse-grad" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    {gradient && (
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#25fb71" />
          <stop offset="0.35" stopColor="#9ff131" />
          <stop offset="0.55" stopColor="#ffc000" />
          <stop offset="0.8" stopColor="#ff6500" />
          <stop offset="1" stopColor="#ff2d00" />
        </linearGradient>
      </defs>
    )}
    <polyline
      points="11,33 22,33 26,26 32,42 37,22 41,33 53,33"
      fill="none"
      stroke={gradient ? `url(#${id})` : "currentColor"}
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

export const Logo = ({ size = 32 }) => (
  <span className="inline-flex items-center gap-2.5">
    <span
      className="inline-flex items-center justify-center rounded-[30%] bg-[#1b2534] ring-1 ring-white/10"
      style={{ width: size, height: size }}
    >
      <Pulse className="h-full w-full" />
    </span>
    <span className="font-display font-bold tracking-tight text-lg text-white">BeaconShield</span>
  </span>
);
